if (!customElements.get('dio-product-sticky-atc')) {
  customElements.define(
    'dio-product-sticky-atc',
    class DioProductStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.sectionId = this.dataset.dioSectionId;
        this.button = this.querySelector('[data-dio-sticky-submit]');
        this.price = this.querySelector('[data-dio-sticky-price]');
        this.primaryButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.primaryButtons = this.primaryButton?.closest('.product-form__buttons');
        if (!this.button || !this.primaryButton) return;
        this.button.disabled = this.primaryButton.disabled;
        const primaryLabel = this.primaryButton.querySelector('[data-product-submit-label]')?.textContent.trim();
        if (primaryLabel) this.button.textContent = primaryLabel;

        this.onClick = () => {
          if (!this.button.disabled) this.primaryButton.click();
        };
        this.button.addEventListener('click', this.onClick);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => this.handleVariantChange(data));
        }
        this.observeVisibility();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.unsubscribe?.();
        this.observers?.forEach((observer) => observer.disconnect());
        this.initialized = false;
      }

      handleVariantChange(data) {
        if (!data || data.sectionId !== this.sectionId) return;
        const { variant, html } = data;
        const available = Boolean(variant?.available);
        const nextPrimaryButton = html?.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const canSubmit = available && !nextPrimaryButton?.hasAttribute('disabled');
        const nextLabel =
          nextPrimaryButton?.querySelector('[data-product-submit-label]')?.textContent.trim() ||
          this.primaryButton.querySelector('[data-product-submit-label]')?.textContent.trim();
        this.button.disabled = !canSubmit;
        this.button.textContent = !variant
          ? nextLabel || this.dataset.dioUnavailableLabel
          : canSubmit
            ? nextLabel || this.dataset.dioAddLabel
            : this.dataset.dioSoldOutLabel;

        const nextPrice = html?.getElementById(`price-${this.sectionId}`);
        if (nextPrice && this.price) this.price.innerHTML = nextPrice.innerHTML;
      }

      observeVisibility() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.state = { purchaseVisible: true, footerVisible: false };
        this.observers = [];
        const update = () => this.classList.toggle('is-visible', !this.state.purchaseVisible && !this.state.footerVisible);

        const purchaseObserver = new IntersectionObserver(([entry]) => {
          this.state.purchaseVisible = entry.isIntersecting && entry.intersectionRatio > 0.2;
          update();
        }, { threshold: [0, 0.2] });
        purchaseObserver.observe(this.primaryButtons || this.primaryButton);
        this.observers.push(purchaseObserver);

        const footer = document.querySelector('.footer');
        if (footer) {
          const footerObserver = new IntersectionObserver(([entry]) => {
            this.state.footerVisible = entry.isIntersecting;
            update();
          });
          footerObserver.observe(footer);
          this.observers.push(footerObserver);
        }
      }
    }
  );
}
